import React, { useContext } from "react";
import styled from "styled-components";

import visaIcon from "../../assets/icons/card-visa.svg";
import masterCardIcon from "../../assets/icons/card-mastercard.svg";
import amexIcon from "../../assets/icons/card-amex.svg";
import defaultCardIcon from "../../assets/icons/default-card.svg";
import { AuthUserContext } from "../../context/AuthUserContext";
import APIService from "../../services/APIService";
import { useTranslation } from "react-i18next";
const CreditCard = ({ card, setCards }) => {
  const { t } = useTranslation();
  const { handleSelectCard, selectedCard, authTokens } =
    useContext(AuthUserContext);
  const getCardIcon = (brand) => {
    switch (brand) {
      case "visa":
        return visaIcon;
      case "mastercard":
        return masterCardIcon;
      case "amex":
        return amexIcon;
      default:
        return defaultCardIcon;
    }
  };
  const handleRemoveCard = async (paymentMethodId) => {
    try {
      await APIService.removePaymentMethod(paymentMethodId, authTokens.access);
      setCards((prevCards) =>
        prevCards.filter((card) => card.id !== paymentMethodId)
      );
      if (selectedCard === paymentMethodId) {
        handleSelectCard(null);
      }
    } catch (error) {
      console.error("Error removing card:", error);
    }
  };
  return (
    <CardItem
      $selected={selectedCard === card.id}
      onClick={() => handleSelectCard(card.id)}
    >
      <CardInfo>
        <FlexDiv>
          <IconContainer>
            <CardIcon src={getCardIcon(card.brand)} alt={card.brand} />
          </IconContainer>
          <PrimaryDiv>
            <RadioButton>
              {selectedCard === card.id && <CheckedRadio />}
            </RadioButton>
            {t("STRIPE.PRIMARY_CARD")}
          </PrimaryDiv>
        </FlexDiv>
        <CardText>{t("STRIPE.CARD_NUMBER")}</CardText>
        <CardBrand>XXXX XXXX XXXX {card.last4}</CardBrand>
        <div style={{ margin: "20px 0" }}>
          <CardText>{t("STRIPE.EXPIRES")}</CardText>
          <FlexDiv>
            <CardExpiry>
              {card.exp_month}/{card.exp_year.toString().slice(-2)}
            </CardExpiry>
            <RemoveDiv
              onClick={(e) => {
                e.stopPropagation(); // Sprečava aktivaciju onClick na kartici
                handleRemoveCard(card.id);
              }}
            >
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 6.38597C3 5.90152 3.34538 5.50879 3.77143 5.50879L6.43567 5.50832C6.96502 5.49306 7.43202 5.11033 7.61214 4.54412C7.61688 4.52923 7.62232 4.51087 7.64185 4.44424L7.75665 4.05256C7.8269 3.81241 7.8881 3.60318 7.97375 3.41617C8.31209 2.67736 8.93808 2.16432 9.66147 2.03297C9.84457 1.99972 10.0385 1.99986 10.2611 2.00002H13.7391C13.9617 1.99986 14.1556 1.99972 14.3387 2.03297C15.0621 2.16432 15.6881 2.67736 16.0264 3.41617C16.1121 3.60318 16.1733 3.81241 16.2435 4.05256L16.3583 4.44424C16.3778 4.51087 16.3833 4.52923 16.388 4.54412C16.5682 5.11033 17.1278 5.49353 17.6571 5.50879H20.2286C20.6546 5.50879 21 5.90152 21 6.38597C21 6.87043 20.6546 7.26316 20.2286 7.26316H3.77143C3.34538 7.26316 3 6.87043 3 6.38597Z"
                  fill="var(--error-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.5956 22.0001H12.4044C15.1871 22.0001 16.5785 22.0001 17.4831 21.1142C18.3878 20.2283 18.4803 18.7751 18.6654 15.8686L18.9321 11.6807C19.0326 10.1037 19.0828 9.31524 18.6289 8.81558C18.1751 8.31592 17.4087 8.31592 15.876 8.31592H8.12404C6.59127 8.31592 5.82488 8.31592 5.37105 8.81558C4.91722 9.31524 4.96744 10.1037 5.06788 11.6807L5.33459 15.8686C5.5197 18.7751 5.61225 20.2283 6.51689 21.1142C7.42153 22.0001 8.81289 22.0001 11.5956 22.0001ZM10.2463 12.1886C10.2051 11.7548 9.83753 11.4382 9.42537 11.4816C9.01321 11.525 8.71251 11.9119 8.75372 12.3457L9.25372 17.6089C9.29494 18.0427 9.66247 18.3593 10.0746 18.3159C10.4868 18.2725 10.7875 17.8856 10.7463 17.4518L10.2463 12.1886ZM14.5746 11.4816C14.9868 11.525 15.2875 11.9119 15.2463 12.3457L14.7463 17.6089C14.7051 18.0427 14.3375 18.3593 13.9254 18.3159C13.5132 18.2725 13.2125 17.8856 13.2537 17.4518L13.7537 12.1886C13.7949 11.7548 14.1625 11.4382 14.5746 11.4816Z"
                  fill="var(--error-color)"
                />
              </svg>
              {t("STRIPE.REMOVE_CARD")}
            </RemoveDiv>
          </FlexDiv>
        </div>
      </CardInfo>
    </CardItem>
  );
};

export default CreditCard;

const CardItem = styled.div`
  margin-bottom: 15px;
  padding: 0 30px;
  border: ${(props) =>
    props.$selected ? "1px solid var(--primary-200)" : "1px solid #ccc"};
  border-radius: 8px;
  background-color: var(--bg-200);
  cursor: pointer;

  &:hover {
    background-color: var(--bg-100);
  }
`;

const CardInfo = styled.div``;
const CardText = styled.p`
  font-weight: 100;
  font-size: var(--font-size-small);
  opacity: 0.6;
  margin-bottom: 4px;
`;

const CardBrand = styled.div`
  letter-spacing: 1.4px;
  font-size: var(--font-size-base);
`;

const CardExpiry = styled.div`
  font-size: var(--font-size-base);
`;
const IconContainer = styled.div`
  width: 80px;
  height: 80px;
`;

const CardIcon = styled.img`
  width: 100%;
  height: 100%;
`;
const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const RemoveDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--error-color);
`;
const PrimaryDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
const RadioButton = styled.div`
  min-width: 16px;
  min-height: 16px;
  max-width: 16px;
  max-height: 16px;
  border-radius: 20px;
  border: 1px solid var(--primary-200);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CheckedRadio = styled.div`
  background-color: var(--primary-200);
  width: 8px;
  height: 8px;
  border-radius: 20px;
`;
